
    import { Vue, Component } from 'vue-property-decorator';

    @Component({
        name: 'Hero1Icon',
    })
    export default class Hero1Icon extends Vue {

    }
